import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailSection } from './components/WhyFailSection';
import { MechanismSection } from './components/MechanismSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FDFBF7] font-sans text-[#2D2D2D]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyFailSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <FAQSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}